<template>
  <async-btn label="Logout" :task="task" v-bind="$attrs" @click="logout" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { logout } from './auth';

interface Data {
  task: Promise<void>|null,
}

export default defineComponent({
  components: { AsyncBtn },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    logout() {
      this.task = logout();
      this.task.then(() => {
        this.$router.push('/login');
      });
    },
  },
});
</script>
